module.exports = __webpack_public_path__ + "static/img/cloud-left-top-min.1db8e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-left-top-min.png
// module id = 654
// module chunks = 64